import React from 'react';
import Markdown from '@splunk/dashboard-visualizations/Markdown';

export default () => (
    <Markdown
        options={{
            markdown: `### A Title
            \nAn h1 Header\n============
            \n* first
            \n* second
            \n* third
            \n* *Italic*
            \n* **bold**
            \nAn h2 header\n------------
            \nHere's a numbered list:
            \n1. first item
            \n1. second item
            \n1. third item`,
        }}
    />
);
